import { AgResourceLanguage } from '../types';
import { toasts as EnUsToasts } from '../en-us/toasts';

export const toasts: AgResourceLanguage['toasts'] = {
  ...EnUsToasts,
  useChangeShippingMethod: {
    nextOrderMethodChanged: 'Leveransmetoden för nästa beställning har ändrats framgångsrikt',
    subscriptionMethodChanged: 'Leveransmetoden för abonnemanget har ändrats framgångsrikt'
  },
  commonError: 'Något gick fel. Försök igen',
  shippingBillingAddress: {
    errorZipCode: 'Ange ett giltigt postnummer',
    errorHtmlTag: 'kan inte innehålla',
    successNextOrder: 'Leveransadressen för nästa beställning har ändrats framgångsrikt',
    successSubscription: 'Leveransadressen för abonnemanget har ändrats framgångsrikt',
    successCheckout: 'Leveransadressen har ändrats framgångsrikt'
  },
  changePaymentMethod: {
    cantRemovePaymentMethod: 'Kan inte ta bort betalningsmetod: felaktigt kund-ID',
    removedPaymentMethod: 'Betalningsmetoden har tagits bort och ändrats framgångsrikt',
    changedPaymentMethod: 'Betalningsmetoden har ändrats framgångsrikt',
    incorrectId: 'Felaktigt beställnings-ID'
  },
  orderCreated: 'Beställningen har skapats',
  migrationToV53: {
    title: 'Din AG1 är uppgraderad!',
    description: 'Ditt abonnemang är nu på den uppgraderade versionen av AG1.'
  }
};
